import {
  SET_USER, LOGIN_REQUEST, LOGIN_SUCCESS, LOGIN_FAILURE, CLEAR_PASSWORD_CHANGE_REQUIRED, SET_DEPLOYMENT_TYPE
} from './constants';


export const requestLogin = (creds) => {
  return {
    type: LOGIN_REQUEST,
    isFetching: true,
    isAuthenticated: false,
    creds
  }
}

export const receiveLogin = (user) => {
 return  {
    type: LOGIN_SUCCESS,
    isFetching: false,
    isAuthenticated: true,
    id_token: user.token
  }
}

export const loginError = (message) => {
  return {
    type: LOGIN_FAILURE,
    isFetching: false,
    isAuthenticated: false,
    message
  }
}

export const OauthLogin = (user) => {
  return dispatch => {
    dispatch(receiveLogin(user))
  }
}

export const logoutUser = () => {
  // We dispatch requestLogin to kickoff the call to the API
  return fetch(window.location.protocol + '//' + window.location.host + '/api/security/logout').then(complete => {
    try { sessionStorage.removeItem('_x3AuthToken'); } catch (_) {}
    window.location.assign('/auth/basic');
  });
}

export const fetchDeploymentType = () => {
  return dispatch => {
    return fetch(window.location.protocol + '//' + window.location.host + '/api/config/get_about')
      .then(res => res.ok ? res.json() : null)
      .then(data => {
        if (data && data.deploymentType) {
          dispatch({ type: SET_DEPLOYMENT_TYPE, payload: data.deploymentType.toLowerCase() });
        }
      })
      .catch(() => {/* non-critical — leave deploymentType as null (treated as onprem) */});
  }
}

export const loginUser = (creds) => {

  creds.username = creds.username.toUpperCase();
  let config = {
    method: 'POST',
    headers: { 'Content-Type':'application/x-www-form-urlencoded' },
    body: `username=${creds.username}&password=${creds.password}`
  }

  return dispatch => {
    // We dispatch requestLogin to kickoff the call to the API
    dispatch(requestLogin(creds))
    return fetch(window.location.protocol + '//' + window.location.host + '/api/security/login', config)
      .then((response) => response.json().then(user => ({ user, response }))).then(({ user, response }) =>
      {
        if (!response.ok)
        {
          // Surface the server's own error message (e.g. rate-limit 429, invalid
          // credentials 401) rather than rejecting into the catch below, which
          // would overwrite it with the generic network-error message.
          dispatch(loginError(user.message))
        }
        else
        {
          // If login was successful, set the token in local storage
          //dispatch(setUser(user.user.username, user.user.locale, user.user.viewPermissions, user.user.docTypePermissions, user.user.localisation))
          dispatch(setUser(user.user.username, user.user._id || user.user.id, user.user.type, user.user.locale, user.viewPermissions, user.docTypePermissions, user.localisation, user.user.requirePasswordChange))
          //Cookies.set('token', user.token);
          //localStorage.setItem('token', user.token);
          dispatch(receiveLogin(user));
          dispatch(fetchDeploymentType());
        }
      }).catch(() => dispatch(loginError('Network error. Please try again.')))
  }
}

export const checkUserAuthetication = () => {
  return dispatch => {
    return fetch(window.location.protocol + '//' + window.location.host + '/api/security/checkToken')
      .then(response =>
        response.json().then(user => ({ user, response }))
        ).then(({ user, response }) =>  {
          if (!response.ok) {
            // 401 = not authenticated — expected on every page load when the user
            // has no active session. Dispatch with no error message so the
            // login page opens clean without a spurious error banner.
            dispatch(loginError(null))
          } else {
            dispatch(setUser(user.user, user.userId, user.userType, user.locale, user.viewPermissions, user.docTypePermissions, user.localisation, user.requirePasswordChange))
            dispatch(receiveLogin(user))
            dispatch(fetchDeploymentType());
          }
      }).catch(() => dispatch(loginError('Network error. Please try again.')))
  }
}

export const getUserFromToken = (token) => {

  let config = {
    method: 'GET',
    headers: {
      'Content-Type':'application/x-www-form-urlencoded',
      'authorization': token
   }
  }

  return dispatch => {
    // We dispatch requestLogin to kickoff the call to the API
    //dispatch(requestLogin({username: '', password: ''}))
    return fetch(window.location.protocol + '//' + window.location.host + '/api/security/checkToken', config)
      .then(response =>
        response.json().then(user => ({ user, response }))
            ).then(({ user, response }) =>  {
        if (!response.ok) {
          // If there was a problem, we want to
          // dispatch the error condition
          dispatch(loginError(user.message))
          return Promise.reject(user)
        } else
        {
          // Persist the session token for the global fetch patch in index.js so
          // all subsequent /api/ calls include an Authorization header.
          // If the server returned a freshToken (issued when the incoming token was
          // a short-lived X3 handoff token), store that instead — it has a full
          // 24h lifetime. Fall back to the original token for backward compatibility.
          try { sessionStorage.setItem('_x3AuthToken', user.freshToken || token); } catch (_) {}
          dispatch(setUser(user.user, user.userId, user.userType, user.locale, user.viewPermissions, user.docTypePermissions, user.localisation, user.requirePasswordChange))
          // Dispatch the success action
          dispatch(receiveLogin(user))
          dispatch(fetchDeploymentType());
        }
      }).catch(() => dispatch(loginError('Network error. Please try again.')))
  }
}

export const setUser = (user, userId, userType, locale, viewpermissions, doctypepermissions, localisation, requirePasswordChange) => {
  return dispatch => {
    dispatch({
       type: SET_USER,
       payload: {
        user,
        userId,
        userType,
        locale,
        viewpermissions,
        doctypepermissions,
        localisation,
        requirePasswordChange: requirePasswordChange ?? false
       }
    })
  }
}

export const clearPasswordChangeRequired = () => ({
    type: CLEAR_PASSWORD_CHANGE_REQUIRED
})
